// pages/NotFound.tsx
import React from "react";
import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <section className="min-h-screen bg-gradient-to-b from-[#F5F3F0] to-white flex items-center justify-center py-16 px-6">
      <div className="max-w-md w-full text-center">
        {/* Error Illustration/Icon */}
        <div className="mb-8">
          <div className="text-9xl font-serif text-[#4E5C36] opacity-20 mb-4">
            404
          </div>
          <div className="h-2 w-32 bg-[#B9A68D] mx-auto mb-6"></div>
        </div>

        {/* Error Message */}
        <h1 className="text-4xl font-serif text-[#4E5C36] mb-4">
          Page Not Found
        </h1>
        <p className="text-gray-600 mb-8 text-lg">
          Sorry, we couldn't find the page you're looking for. The page might
          have been moved, deleted, or you entered an incorrect URL.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 bg-[#4E5C36] text-white px-6 py-3 rounded-lg hover:bg-[#3a4630] transition-colors duration-200 font-medium"
          >
            <Home className="h-4 w-4" />
            Back to Home
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 border border-[#B9A68D] text-[#4E5C36] px-6 py-3 rounded-lg hover:bg-[#B9A68D]/10 transition-colors duration-200 font-medium"
          >
            <ArrowLeft className="h-4 w-4" />
            Go Back
          </button>
        </div>

        {/* Additional Help */}
        <div className="mt-10 p-4 bg-[#B9A68D]/10 rounded-lg">
          <p className="text-sm text-gray-600">
            If you believe this is an error, please{" "}
            <a
              href="mailto:support@example.com"
              className="text-[#4E5C36] underline"
            >
              contact support
            </a>
            .
          </p>
        </div>
      </div>
    </section>
  );
}
